import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import { ChevronLeftIcon, ChevronRightIcon, ArrowPathIcon } from '@heroicons/react/20/solid'
import TemplateTable from "../../component/templatetable/TemplateTable";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export default function TemplateList() {

    const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS

    const [data, setData] = useState();
    const [isReseeding, setIsReseeding] = useState(false);

const id = window.location.pathname.split("/")[2]


    useEffect(() => {
        Axios ({
           method: "GET",
          withCredentials: true,
            url: `${backEndUrl}/auth/consultantLog`,
     
         
          }).then((res) => {
           setData(res.data);       
          });
     }, []) 

    const handleResetToDefaults = async () => {
        if (!window.confirm('This will replace all your templates with the default ones. Any custom templates or edits will be lost. Continue?')) return;
        setIsReseeding(true);
        try {
            await Axios.put(`${backEndUrl}/updateClient/reseedTemplates/${data.id}`, {}, { withCredentials: true });
            window.location.reload();
        } catch (err) {
            console.error('Failed to reseed templates:', err);
            alert('Something went wrong. Please try again.');
        } finally {
            setIsReseeding(false);
        }
    };

    
     

     if (data === undefined) {

        return (
            <div style={{marginTop:'20%', marginLeft:'50%' }}>  
      <CircularProgress color="secondary" />
      </div>  
        )
    }
    
    else {

    return (
        <div className="px-10 pb-10">
    <div className="mt-8">
      <div>
        <nav aria-label="Back" className="sm:hidden">
          <a href="#" className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <ChevronLeftIcon aria-hidden="true" className="-ml-1 mr-1 h-5 w-5 shrink-0 text-gray-400" />
            Back
          </a>
        </nav>
        <nav aria-label="Breadcrumb" className="hidden sm:flex">
          <ol role="list" className="flex items-center space-x-4">
            <li>
              <div className="flex">
                <a href="#" className="text-sm font-medium text-gray-500 hover:text-gray-700">
                  List
                </a>
              </div>
            </li>
            <li>
              <div className="flex items-center">
                <ChevronRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-gray-400" />
                <a href="#" className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">
                  Templates
                </a>
              </div>
            </li>
        
          </ol>
        </nav>
      </div>
      <div className="mt-2 md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl/7 mt-2 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Your templates
          </h2>
        </div>
        <div className="mt-4 flex shrink-0 gap-3 md:ml-4 md:mt-0">
          {/* <button
            onClick={handleResetToDefaults}
            disabled={isReseeding}
            className="inline-flex items-center gap-2 bg-white border border-gray-300 text-gray-600 hover:text-gray-800 hover:border-gray-400 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all disabled:opacity-50"
          >
            <ArrowPathIcon className={`h-4 w-4 ${isReseeding ? 'animate-spin' : ''}`} />
            Reset to Defaults
          </button> */}
          <Link
            to="/dashboard/new-template"
            className="inline-flex items-center gap-2 bg-[#0a79be] hover:bg-[#0052CC] text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-sm hover:shadow transition-all no-underline"
          >
            Create new template
          </Link>
        </div>
          </div>
          </div>

 

     <TemplateTable
              templates={data.docTemplates}
              storageUsed={data.storageUsed}
              preferredLanguage={data.preferredLanguage}
   
        /> 
        </div>
    )
}
}
